import { Controller } from "@hotwired/stimulus"

// Simple toggle controller for showing/hiding elements
export default class extends Controller {
  static targets = ["element"]

  toggle(event) {
    const input = event.target

    this.elementTargets.forEach((element) => {
      // Handle checkboxes
      if (input.type === "checkbox") {
        if (input.checked) {
          element.classList.remove("hidden")
        } else {
          element.classList.add("hidden")
        }
      }
      // Handle radio buttons - show when value is "false" (different address), hide when "true"
      else if (input.type === "radio") {
        if (input.value === "false" && input.checked) {
          element.classList.remove("hidden")
        } else if (input.value === "true" && input.checked) {
          element.classList.add("hidden")
        }
      }
    })
  }
}
